import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Grid, IconButton, Button, Divider, Paper, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Tooltip, CircularProgress, Checkbox } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Restore';
import Alert from '@material-ui/lab/Alert';
import { Pagination } from '@material-ui/lab';
import Page from '../../atoms/page';
import { StyledTableCell, StyledTableCellHead, StyledTableRow } from '../../atoms/table/tableStyles';
import { initiateRestore } from "../../../store/blueprint/actions";
import SearchField from '../../molecules/blueprint/SearchField'
import { searchForBackups } from '../../../store/backup_restore/actions'
import DeleteBackupAlert from '../../molecules/alerts/DeleteBackupAlert';
import { backupRestoreConfig } from '../../../config/common'
import { handleSnackBar, setReRender, setTriggerBlueprintValidation } from "../../../store/global/actions";
import dayjs from 'dayjs';
import { getSnackBarProps } from '../../../store/global/selectors';



const BackupRestore = (props) => {
    const browserTabTitle = props?.browserTabTitle;
    const setClearAlert = props?.setClearAlert;
    const customStyle = props?.customStyle;
    const dispatch = useDispatch();
    const [backUps, setBackups] = useState(null);
    const [error, setError] = useState(null);
    const [succesAlert, setSuccessAlert] = useState(null)
    const [restoreInProgress, setRestoreInProgress] = useState(false);
    const [deletePayload, setDeletePayload] = useState(null);
    const [page, setPage] = useState(1);
    const [searchInProgress, setSearchInProgress] = useState(false);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [selectedBackups, setSelectedBackups] = useState([]);

    const showInProgressInTable = localStorage.getItem("backupInProgress") !== undefined && localStorage.getItem("backupInProgress") !== null ? true : false; 
    
    let url = window.location.pathname
    const snackbarMessage = useSelector(getSnackBarProps);

    let segments = url.split('/');
    let blueprintId = segments[3]

    const form = useForm();
    const { getValues } = form;

    const keywordInput = getValues('keyword') || '';

    const ROWS_PER_PAGE = backupRestoreConfig.rowsPerPage || 20;
    const payload = { blueprintId: blueprintId, keyword: keywordInput || '' }

    const getBackups = () => {
        setSuccessAlert(null);
        setError(null);
        dispatch(searchForBackups(payload, ROWS_PER_PAGE, page)).then((result) => {
            if (result.status) {
                setBackups(result);
                setNumberOfPages(Math.ceil(result?.recordCount?.[0]?.totalRecords / ROWS_PER_PAGE))
            }else {
                setError(result.error);
            }
        })
    }

    const changeDateTimeToLocal = (datetime) => {
        const newDate = new Date(datetime).toISOString();
        const formattedDate = dayjs(newDate).format("YYYY-MM-DD HH:mm:ss");
        return formattedDate;
    }


    function handleBackUpSearch(data) {
        const payload = { ...data, blueprintId: blueprintId, date: data.date ? data.date.setUTCHours(0, 0, 0, 0) : undefined };
        setBackups(null);
        setSuccessAlert(null);
        setError(null);
        setSearchInProgress(true)
        setPage(1)
        setNumberOfPages(0)
        dispatch(searchForBackups(payload, ROWS_PER_PAGE, page)).then((result) => {
            if (result.status) {
                setBackups(result);
                let totCount = result?.recordCount % ROWS_PER_PAGE;
                setNumberOfPages(Math.ceil(result?.recordCount?.[0]?.totalRecords / ROWS_PER_PAGE))
            }
            else {
                setError(result.error);
            }
            setSearchInProgress(false)

        })

    }

    const requestRestore = async (restoreData) => {
        if (setClearAlert !== undefined) setClearAlert(true);
        setSuccessAlert(null);

        setError(null);
        setRestoreInProgress(true);
        const payload = { blueprintId: restoreData.blueprintId, date: restoreData.date, backupId: restoreData._id };
        dispatch(initiateRestore(payload)).then(result => {
            setRestoreInProgress(false);
            if (result.status == false) {
                // setError(result.error);
            } else {
                if (result.blueprintId != undefined) {
                    props.history.push(`/blueprint/${result?.slug}/${result?.blueprintId}/system-model`);
                    dispatch(handleSnackBar({ open: true, message: 'Blueprint restored!', severity: "success" }));
                    dispatch(setReRender());
                    dispatch(setTriggerBlueprintValidation());
                    // dispatch(detectPlatformSchemaChange())
                }

            }
        })
    }

    const onDelete = (restoreData) => {
        setSuccessAlert(null)
        setDeletePayload(restoreData)
    }

    const onDeleteCompletion = (response) => {
        setBackups(null);
        setNumberOfPages(0)
        if (response.status) {
            dispatch(searchForBackups(payload, ROWS_PER_PAGE, page)).then((backedUpData) => {
                setBackups(backedUpData);
                setNumberOfPages(Math.ceil(backedUpData?.recordCount?.[0]?.totalRecords / ROWS_PER_PAGE))
                setSuccessAlert(response.message)
                dispatch(handleSnackBar({ open: true, message: 'Backup Deleted', severity: 'success' }))
            })
        } else {
            setError(response.message)
            dispatch(handleSnackBar({ open: true, message: 'Backup Delete Failed', severity: 'error' }))
        }
        setSelectedBackups([])
    }

    const onBackupSelect = (backup, checked) => {
        checked ? setSelectedBackups([...selectedBackups, backup]) : setSelectedBackups(selectedBackups.filter(n => n._id !== backup._id));
    }

    useEffect(() => {
        getBackups();
    }, [page])

    useEffect(() => {
        if (snackbarMessage !== undefined && snackbarMessage.message === "Backup completed") {
            setPage(1)
            setBackups(null)
            setTimeout(getBackups, 500);
        }
    }, [snackbarMessage])

    const alertStyle = { marginBottom: 10, marginTop: 10 }

    
    // useEffect(() => {
    //     dispatch(triggerTour({currentTour: 'backupRestore'}))
    // },[])

    return (
        <Page title={browserTabTitle !== undefined ? browserTabTitle : "Backup and Restore"} customStyle={customStyle} style={{ marginTop123: "-64px" }}>
            <>
                <Grid container direction="row" spacing={2} style={{ marginBottom: '20' }}>
                    <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }} data-ui-tour-id="search-field-container">
                        <SearchField form={form} handleBackUpSearch={handleBackUpSearch} searchInProgress={searchInProgress} />
                    </Grid>
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => onDelete(selectedBackups)} color="secondary" disabled={selectedBackups.length == 0} variant="contained" style={{ minWidth: "200px", textTransform: 'capitalize' }}>Delete</Button>
                    </Grid>

                </Grid>

                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container direction="row" spacing={2}>

                    <Grid item xs={12}>
                        {error && <Alert variant="filled" style={alertStyle} severity="error">{error}</Alert>}
                        {restoreInProgress && <Alert variant="filled" style={alertStyle} severity="info" id="restore-alert" >Attemptig to restore...</Alert>}
                    </Grid>

                    <Grid item xs={12} style={{ height: 'auto', overflow: 'auto', width: '600px' }} data-ui-tour-id='backup-table'>
                        {<TableContainer component={Paper} style={{boxShadow: 'none', borderRadius: 0}}>

                            <Table aria-label="customized table" id="backup_restore_table" >
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCellHead align='left' style={{ width: 30 }}></StyledTableCellHead>
                                        <StyledTableCellHead align='left' style={{ width: 30 }}>Blueprint Name</StyledTableCellHead>
                                        <StyledTableCellHead align='left' style={{ width: 30 }}>Message</StyledTableCellHead>
                                        <StyledTableCellHead align='left' style={{ width: 30 }}>Location</StyledTableCellHead>
                                        <StyledTableCellHead align='left' style={{ width: 100 }}>Date</StyledTableCellHead>
                                        <StyledTableCellHead align='right' style={{ width: 70 }}></StyledTableCellHead>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {showInProgressInTable && (
                                        <StyledTableRow>
                                            <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                                Backup in progress... <CircularProgress size={15} style={{ color: '#000' }} />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )
                                    }
                                    {(backUps === undefined || backUps == null) && !showInProgressInTable ?
                                        <StyledTableRow>
                                            <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                                Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        : (backUps?.data === undefined || backUps?.data.length < 1) && !showInProgressInTable ?
                                            <StyledTableRow>
                                                <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                                    No backups available.
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        : backUps?.data.map((restore, index) => (
                                            <StyledTableRow className='backup-data-row' key={index + 1}>

                                                <StyledTableCell align={'left'} component="td" style={{ width: 30 }}>
                                                    <Checkbox size='small' color='primary' onChange={e => onBackupSelect(restore, e.target.checked)} />
                                                </StyledTableCell>

                                                <StyledTableCell align={'left'} component="td" style={{ width: 30 }}>
                                                    <div dangerouslySetInnerHTML={{ __html: restore?.blueprintName?.replace(keywordInput, match => `<span style="color:red">${match}</span>`) }} />
                                                </StyledTableCell>

                                                <StyledTableCell align={'left'} component="td" width='10%' style={{ width: 30 }}>
                                                    {/* <div dangerouslySetInnerHTML={{ __html: restore?.messsage?.replace(keywordInput, match => `<span style="color:red">${match}</span>`) }} /> */}
                                                    {restore?.message !== undefined ? restore.message :  "" }
                                                </StyledTableCell>

                                                <StyledTableCell align={'left'} component="td" width='10%' style={{ width: 30 }}>
                                                    {restore?.type === "git" ? "Git repository" : "Hyperblox cloud" }
                                                </StyledTableCell>

                                                <StyledTableCell align={'left'} component="td" style={{ width: 100 }} >
                                                    {restore.date ? changeDateTimeToLocal(restore.date) : ''}
                                                </StyledTableCell>

                                                <StyledTableCell align="right" style={{ width: 70 }}>
                                                    <Tooltip title="Restore blueprint">
                                                        <IconButton size='small'  disabled={restoreInProgress} onClick={() => { requestRestore(restore) }} color="primary" aria-label="upload picture" component="span">
                                                            <RestoreIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete backup">
                                                        <IconButton size="small" disabled={restoreInProgress} onClick={() => onDelete(restore)} color="secondary" aria-label="upload picture" component="span">
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>

                                                </StyledTableCell>

                                            </StyledTableRow>
                                        )) 
                                    }

                                </TableBody>
                            </Table>
                            <Table aria-label="customized table" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right" component="td" style={{ width: 20, padding: '10px', border: '2px solid rgba(224, 224, 224, 1)', borderTop: 0 }}>
                                            <Pagination
                                                count={numberOfPages}
                                                color='secondary'
                                                varient='outlined'
                                                page={page}
                                                onChange={(event, value) => setPage(value)}
                                                style={{ display: "flex", justifyContent: "flex-end" }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                            </Table>

                        </TableContainer>}
                    </Grid>

                    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
                        {props.onClose !== undefined && <Button onClick={props.onClose} variant="contained" style={{ marginLeft: 10, textTransform: 'capitalize' }}>
                            Cancel
                        </Button>}
                    </Grid>

                </Grid>
                {deletePayload != null && <DeleteBackupAlert onCompletion={onDeleteCompletion} onClose={() => setDeletePayload(null)} deletePayload={deletePayload} />}
            </>
        </Page >
    )

}

export default withRouter(BackupRestore)
